import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(`${import.meta.env.MICRO_SITE_BASE_URL}/index/main`),

  routes: [
    {
      path: '/2024',
      component: () => import('../views/reader.vue'),
      props: () => ({
        pageKey: '2024-4',
        url: 'https://res.oafimg.cn/-/9356ffd564f7a525/2024-4.pdf',
      }),
      meta: {
        title: '中国开源发展深度报告（2024）',
      },
    },
    {
      path: '/2025',
      component: () => import('../views/reader.vue'),
      props: () => ({
        pageKey: '2025-2',
        url: 'https://res.oafimg.cn/-/f773ab50be9f4a6b/2025-2.pdf',
      }),
      meta: {
        title: '中国开源发展深度报告（2025）',
      },
    },
  ],
});

router.beforeEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title as string;
  }
});

export default router;
